import { PlusOutlined } from "@ant-design/icons";
import { faClockRotateLeft, faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Switch, Table, Tooltip } from "antd";
import { ProhibitedArea } from "components";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;

const UserList = ({ userList, onAddUser, onViewUser, onEditUser, onActivateDeactiveUser, onViewUserHistory, permission }) => {
    if (!permission) {
        return <ProhibitedArea></ProhibitedArea>;
    }

    return (
        <FlexContainerLayout
            footer={
                <Button type="primary" data-testid={CypressTestIds.USERS_ADD_USER_BUTTON} disabled={!permission.canAdd} onClick={onAddUser}>
                    <PlusOutlined /> Add User
                </Button>
            }
        >
            <Table
                data-testid={CypressTestIds.USERS_USERSLIST_TABLE}
                size="small"
                rowKey="userId"
                dataSource={userList}
                pagination={false}
                className="flex size-full flex-1 flex-col [&_thead]:sticky [&_thead]:top-0 [&_thead]:z-10 [&_thead]:bg-header-footer [&_thead]:text-header-footer"
            >
                <Column
                    width="6em"
                    render={(value, user, index) => (
                        <>
                            <Tooltip title="Edit user">
                                <FontAwesomeIcon
                                    icon={faPencil}
                                    data-testid={CypressTestIds.USERS_USERSLIST_EDIT_BUTTON}
                                    className={permission.canEdit ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    onClick={() => (permission.canEdit ? onEditUser(user.userId) : null)}
                                />{" "}
                            </Tooltip>
                            <Tooltip title="View User">
                                <FontAwesomeIcon
                                    icon={faEye}
                                    data-testid={CypressTestIds.USERS_USERSLIST_VIEW_BUTTON}
                                    className={permission.canView ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    onClick={() => (permission.canView ? onViewUser(user.userId) : null)}
                                />{" "}
                            </Tooltip>
                            <Tooltip title="View User History">
                                <FontAwesomeIcon
                                    icon={faClockRotateLeft}
                                    data-testid={CypressTestIds.USERS_USERSLIST_HISTORY_BUTTON}
                                    className={permission.canView ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    onClick={() => (permission.canView ? onViewUserHistory(user.userId) : null)}
                                />{" "}
                            </Tooltip>
                        </>
                    )}
                />
                <Column
                    dataIndex="email"
                    title="UserID"
                    ellipsis={{
                        showTitle: false,
                    }}
                    render={(value, user, index) => (
                        <Tooltip placement="topLeft" title={value}>
                            {value}
                        </Tooltip>
                    )}
                />
                <Column
                    dataIndex="firstName"
                    title="Name"
                    ellipsis={{
                        showTitle: false,
                    }}
                    render={(value, user, index) => <Tooltip placement="topLeft" title={`${user.firstName} ${user.lastName}`}>{`${user.firstName} ${user.lastName}`}</Tooltip>}
                />
                <Column
                    width="20%"
                    dataIndex="assignedBusinessAreaCount"
                    title="Assigned Business Areas"
                    ellipsis={{
                        showTitle: false,
                    }}
                    render={(value, user, index) => (
                        <Tooltip placement="topLeft" title={value}>
                            {value}
                        </Tooltip>
                    )}
                />
                <Column
                    width="15%"
                    dataIndex="assignedRoleCount"
                    title="Assigned Roles"
                    ellipsis={{
                        showTitle: false,
                    }}
                    render={(value, user, index) => (
                        <Tooltip placement="topLeft" title={value}>
                            {value}
                        </Tooltip>
                    )}
                />
                <Column
                    width="10%"
                    dataIndex="active"
                    title={"Active"}
                    ellipsis={{
                        showTitle: false,
                    }}
                    render={(value, user, index) => {
                        return (
                            <Switch
                                data-testid={CypressTestIds.USERS_USERSLIST_ACTIVE_SWITCH}
                                checked={value}
                                disabled={!permission.canEdit || user.userType === "ACCOUNT_ADMIN"}
                                onClick={(checked, event) => onActivateDeactiveUser(user, checked)}
                            ></Switch>
                        );
                    }}
                />
            </Table>
        </FlexContainerLayout>
    );
};

export default UserList;
